import React from 'react'
import { motion } from 'framer-motion'
import { IconSun, IconMoon } from '@tabler/icons-react'
import { useTheme } from '../../hooks/useTheme'

const ThemeToggle = ({ size = 'md' }) => {
  const { theme, toggleTheme, isDark } = useTheme()

  const sizeClasses = {
    sm: 'w-12 h-6',
    md: 'w-14 h-7',
    lg: 'w-16 h-8'
  }

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  }

  return (
    <motion.button
      onClick={toggleTheme}
      className={`relative ${sizeClasses[size]} rounded-full backdrop-blur-md border border-white/20 transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500/50 flex items-center`}
      style={{
        background: isDark
          ? 'linear-gradient(135deg, rgba(30, 41, 59, 0.9), rgba(51, 65, 85, 0.9))'
          : 'linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.9))',
        boxShadow: 'var(--shadow-elegant)',
        padding: '2px'
      }}
      whileTap={{ scale: 0.95 }}
      title={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    >
      {/* Track background */}
      <div className="absolute inset-0 rounded-full overflow-hidden">
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{
            background: isDark 
              ? 'linear-gradient(135deg, #1e293b, #334155)'
              : 'linear-gradient(135deg, #fbbf24, #f59e0b)'
          }}
          animate={{
            opacity: isDark ? 0.8 : 1
          }}
          transition={{ duration: 0.3 }}
        />
      </div>

      {/* Sliding toggle */}
      <motion.div
        className="relative z-10 rounded-full backdrop-blur-md border border-white/30 shadow-lg flex items-center justify-center"
        style={{
          background: isDark
            ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.8), rgba(99, 102, 241, 0.8))'
            : 'linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(248, 250, 252, 0.95))',
          width: size === 'sm' ? '20px' : size === 'md' ? '24px' : '28px',
          height: size === 'sm' ? '20px' : size === 'md' ? '24px' : '28px',
          flexShrink: 0
        }}
        animate={{
          x: isDark ? (size === 'sm' ? 22 : size === 'md' ? 26 : 30) : 0
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 30
        }}
      >
        {isDark ? (
          <IconMoon className={`${iconSizes[size]} text-white`} />
        ) : (
          <IconSun className={`${iconSizes[size]} text-yellow-600`} />
        )}
      </motion.div>

      {/* Background icons */}
      <div className="absolute inset-0 flex items-center justify-between px-2 pointer-events-none">
        <motion.div
          animate={{ 
            opacity: isDark ? 0.3 : 0.7,
            scale: isDark ? 0.8 : 1
          }}
          transition={{ duration: 0.3 }}
        >
          <IconSun className={`${iconSizes[size]} text-yellow-600`} />
        </motion.div>
        <motion.div
          animate={{ 
            opacity: isDark ? 0.7 : 0.3,
            scale: isDark ? 1 : 0.8
          }}
          transition={{ duration: 0.3 }}
        >
          <IconMoon className={`${iconSizes[size]} text-blue-300`} />
        </motion.div>
      </div>
    </motion.button>
  )
}

export default ThemeToggle